import Container from './Container';
import Column from './Column';

export default Object.assign(Container, {
  Column
});
